import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "outRelation",
  "use": "outRelation-usage",
  "viewBox": "0 0 18.09 18.09",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.09 18.09\" id=\"outRelation\"><title>外部关系角色</title><path d=\"M12.33,10.92a10.79,10.79,0,0,0-1-.88,5.07,5.07,0,0,0-1-8.8A4.66,4.66,0,0,1,12,.91a4.94,4.94,0,0,1,4.85,5A4.93,4.93,0,0,1,12.33,10.92Zm0-5a4.94,4.94,0,0,1-4.84,5,4.94,4.94,0,0,1-4.85-5,4.94,4.94,0,0,1,4.85-5,4.94,4.94,0,0,1,4.85,5ZM4.27,10.67A4.72,4.72,0,0,0,7.49,12L5.55,16l1.94,1.84L9.43,16,7.49,12a4.72,4.72,0,0,0,3.22-1.3c3,1.55,3.56,5.32,3.56,8.33H.7c0-3,.58-6.78,3.56-8.33Zm9,1.1a4.84,4.84,0,0,0,2-1.1c3,1.55,3.56,5.32,3.56,8.33H15.4c0-.13,0-.26,0-.39s0-.11,0-.17a10.81,10.81,0,0,0-.09-1.32,9,9,0,0,0-2.06-5.34Z\" transform=\"translate(-0.7 -0.91)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/outRelation.svg
// module id = w3Rr
// module chunks = 268